import { Component } from 'react'
import Select from 'react-select'
import Typeahead from '../helpers/Typeahead'
import { FormattedMessage } from 'react-intl'
import FilterList from './FilterList'
import GuestPicker from '../forms/GuestPicker'

export const autosuggestStyles = {
  control: styles => ({
    ...styles,
    borderRadius: 2,
    border: '1px solid #dde3e6',
  }),
  valueContainer: styles => ({
    ...styles,
    paddingLeft: 40,
  }),
  clearIndicator: styles => ({
    ...styles,
    cursor: 'pointer',
  }),
  menu: styles => ({
    ...styles,
    zIndex: 9999,
  }),
  option: (styles, state) => {
    return ({
      ...styles,
      backgroundColor: state.isFocused ? '#f23d4e' : null,
      color: state.isFocused ? '#fff' : null,
      '&:active': {
        backgroundColor: '#ce4028',
        color: '#fff',
      },
    })
  },
}

export default class FiltersLa extends Component {
  constructor(props) {
    super(props)

    this.state = {
      title: '',
      filtersToggler: {
        price: true,
        duration: true,
        diving_intensity: true,
        experience: true,
      },
      monthes: props.monthes,
    }

    this.toggleFilter = this.toggleFilter.bind(this)
  }

  toggleFilter(filterId) {
    let filtersToggler = Object.assign({}, this.state.filtersToggler)

    filtersToggler[filterId] = !filtersToggler[filterId]

    this.setState({
      filtersToggler,
    }, () => {
      console.log(this.state.filtersToggler)
    })
  }

  updateMonth(selectedOption) {
    if(!selectedOption) {
      this.props.clearDates()
    } else {
      this.props.updateParams({
        'departure_date_month': selectedOption,
        'departure_date': selectedOption.from,
      })
    }
  }

  updateCheckbox = (filter, id, value, item = {}) => {
    let secondLevelItems = {}
    if(item.subitems && item.subitems.length > 0) {
      secondLevelItems = {
        'marine_life_critters': { ...this.props.selectedFilters.marine_life_critters },
      }

      item.subitems.map(function(subitem) {
        secondLevelItems['marine_life_critters'][subitem.id] = value
      })
    }

    this.props.updateParams({
      [filter]: {
        ...this.props.selectedFilters[filter],
        [id]: value,
      },
      ...secondLevelItems,
    })
  }

  handleGuestsChange = ({ guests_split, divers, nonDivers, students, rooms }) => {
    this.props.updateParams({
      guests_split: divers || nonDivers || students ? guests_split : undefined,
      divers,
      nonDivers,
      students,
      rooms,
    })
  }

  render() {
    return (
      <div className='filters'>
        <div className='main-filters' id='la-main-filters'>
          <p className='title'><FormattedMessage id='search' defaultMessage='Search' /></p>
          <div className='pt-selector results-type'>
            <a className='option' href={this.props.resortDetails && this.props.resortDetails.searchUrl}>
              <i className='font-icons dive-resort-icon' />
              <span><FormattedMessage id='dive_resorts' defaultMessage='Dive resorts' /></span>
            </a>

            <a className='option active'>
              <i className='font-icons liveaboard-icon' />
              <span><FormattedMessage id='liveaboards' defaultMessage='Liveaboards' /></span>
            </a>
          </div>
          <div className='search-block'>
            <label className='w_icon'>
              <i className='font-icons field-icon location-icon' />
              <Typeahead isWidget={this.props.isWidget} kind={10} inputValue={this.props.title} popupId='country-list-popup' />
            </label>
          </div>
          <div className={`form-group w_icon ${!this.props.selectedFilters.departure_date_month ? 'has-error' : ''}`}>
            <GuestPicker hideError isLiveaboard noStudentsPackages onSelect={this.handleGuestsChange} showIcon selectedGuests={this.state.selectedGuests} />
          </div>
          <div className={`form-group w_icon ${!this.props.selectedFilters.departure_date_month ? 'has-error' : ''}`}>
            <i className='font-icons field-icon calendar-icon' />
            <Select
              onChange={(selectedOption) => this.updateMonth(selectedOption)}
              value={this.props.selectedFilters.departure_date_month}
              options={this.state.monthes}
              styles={autosuggestStyles}
              isSearchable={false}
              valueKey='id'
              isClearable
              className='select-container'
              classNamePrefix='select-container' />
          </div>
          <button className='btn-red' id='search-btn' onClick={this.props.triggerApi}>
            <i className='font-icons find-icon' />
            <FormattedMessage id='search' defaultMessage='Search' />
          </button>
          {/* { this.props.selectedFilters.departure_date_month ?
          (
            <span onClick={ this.props.clearDates }>
            <FormattedMessage id='clear_dates'  defaultMessage='Clear dates' />
            </span>
          ) : ''
        } */}
        </div>
        <FilterList
          updateParams={this.props.updateParams}
          selectedFilters={this.props.selectedFilters}
          items={this.props.items}
          clearSelectedFilters={this.props.clearSelectedFilters}
          filtersCount={this.props.filtersCount}
        />
        <div className='shadow-block'>
          <p className='title text-center'><FormattedMessage id='padi_traveler_reviews' defaultMessage='PADI travel reviews' /></p>
          <div className='trust-pilot text-center'>
            <div
              className='trustpilot-widget'
              data-locale={this.props.trustpilotLocale}
              data-template-id='53aa8912dec7e10d38f59f36'
              data-businessunit-id='55eeddbb0000ff00058313b3'
              data-style-height='130px' data-style-width='100%'
              data-theme='light'
              data-stars='5'
              data-schema-type='Organization'>
              <a href='https://www.trustpilot.com/review/travel.padi.com' target='_blank'>Trustpilot</a></div>
          </div>
        </div>
      </div>
    )
  }
}

// export default connect(
//   state => ({
//       pageLoader: state.pageLoader,
//   })
// )(FiltersLa)
